/* After an EasySell COD order: save the order details for the Arabic thank-you page and send the buyer there
   instead of Shopify's order status page. EasySell awaits window.es_hook_before_redirect(order) before its own redirect. */
(() => {
  const PAGE = '/pages/shukran';
  window.es_hook_before_redirect = async (o) => {
    let n = '';
    try {
      o = o || {};
      const ship = o.shipping_address || o.billing_address || {};
      const cust = o.customer || {};
      n = String(o.order_number || String(o.name || '').replace(/[^\d]/g, '') || '');
      sessionStorage.setItem('jsl_order', JSON.stringify({
        n,
        name: [ship.first_name || cust.first_name || '', ship.last_name || ''].join(' ').trim(),
        city: ship.city || '',
        total: o.total_price || '',
        qty: (o.line_items || []).reduce((a, x) => a + (x.quantity || 0), 0),
        status: o.order_status_url || '',
        t: Date.now(),
      }));
    } catch (e) {}
    await new Promise((r) => setTimeout(r, 900)); // let the Purchase pixel requests leave first
    location.replace(PAGE + (n ? '?o=' + encodeURIComponent(n) : ''));
    await new Promise(() => {}); // keep EasySell from running its own redirect
  };
})();
